import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bdp-date-time-filter',
  templateUrl: './date-time-filter.component.html',
  styleUrls: ['./date-time-filter.component.scss'],
  standalone :false,
})
export class DateTimeFilterComponent implements OnInit, AfterViewInit {
  @Input() years: Array<string> = ["2020", "2021"];
  @Output() dateChange = new EventEmitter<number>();
  @Input() filters: any = [];
  public dateFilters: any = {
    years: [],
    criteria: { key: 'YEARS', value: 'Years' },
    criterias: [
      { key: 'YEARS', value: 'Years' },
      { key: 'QUARTERS', value: 'Quarters' },
      { key: 'MONTHS', value: 'Months' },
    ],
    values: [0, 1],
    customValues: ["", ""],
    min: 0,
    max: 1,
    months: ['JAN', 'FEB', 'MAR', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
    typeChange: function () {
      switch (this.criteria.key) {
        case "YEARS": {
          this.min = 0;
          this.max = this.years.length - 1
          break;
        }
        case "QUARTERS": {
          this.min = 0;
          this.max = (this.years.length * 4) - 1;
          break;
        }
        case "MONTHS": {
          this.min = 0;
          this.max = (this.years.length * 12) - 1;
          break;
        }
      }
      this.values = [0, 1];
      this.filterChange();
    },
    filterChange: function () {
      switch (this.criteria.key) {
        case "YEARS": {
          this.customValues = [this.years[this.values[0]], this.years[this.values[1]]];
          break;
        }
        case "QUARTERS": {
          let year1 = "";
          let year2 = "";
          const yearIndex1 = Math.floor((this.values[0]) / 4);
          const yearIndex2 = Math.floor((this.values[1]) / 4)
          const quaterIndex1 = Math.floor((this.values[0] + 1) % 4);
          const quaterIndex2 = Math.floor((this.values[1] + 1) % 4);
          year1 = "Q" + (quaterIndex1 == 0 ? 4 : quaterIndex1) + " " + this.years[yearIndex1];
          year2 = "Q" + (quaterIndex2 == 0 ? 4 : quaterIndex2) + " " + this.years[yearIndex2];
          this.customValues = [year1, year2];
          break;
        }
        case "MONTHS": {
          const year1 = Math.floor(this.values[0] / 12);
          const year2 = Math.floor(this.values[1] / 12);
          const month1 = Math.floor((this.values[0]) % 12);
          const month2 = Math.floor((this.values[1]) % 12);
          this.customValues = [
            this.months[month1] + " " + this.years[year1],
            this.months[month2] + " " + this.years[year2]];
          break;
        }
      }
      // console.log(this.customValues);
    },
  };

  constructor() {
  }

  ngAfterViewInit() {
  }

  updateFilter() {
    const months: any = {
      'JAN': {
        index: 1, max: 31
      }, 'FEB': {
        index: 2, max: 28
      }, 'MAR': {
        index: 3, max: 31
      }, 'APRIL': {
        index: 4, max: 30
      }, 'MAY': {
        index: 5, max: 31
      }, 'JUNE': {
        index: 6, max: 30
      }, 'JULY': {
        index: 7, max: 31
      }, 'AUG': {
        index: 8, max: 31
      }, 'SEP': {
        index: 9, max: 30
      }, 'OCT': {
        index: 10, max: 31
      }, 'NOV': {
        index: 11, max: 30
      }, 'DEC': {
        index: 12, max: 31
      }
    };
    const quater: any = {
      'Q1': {
        start: 1,
        end: 3,
        max: 31
      },
      'Q2': {
        start: 4,
        end: 6,
        max: 30
      },
      'Q3': {
        start: 7,
        end: 9,
        max: 30
      },
      'Q4': {
        start: 10,
        end: 12,
        max: 31
      }
    };
    const filters: any = [];
    switch (this.dateFilters.criteria.key) {
      case "YEARS": {
        filters[0] = "01/01/" + this.dateFilters.customValues[0];
        filters[1] = "31/12/" + this.dateFilters.customValues[1];
        break;
      }
      case "QUARTERS": {
        this.dateFilters.customValues.map((value: any, index: number) => {
          const quaterString = value.split(" ");
          if (index == 0) {
            filters[0] = "01/" + quater[quaterString[0]].start + "/" + quaterString[1];
          }
          if (index == 1) {
            filters[1] = quater[quaterString[0]].max + "/" + quater[quaterString[0]].end + "/" + quaterString[1];
          }
        });
        break;
      }
      case "MONTHS": {
        this.dateFilters.customValues.map((value: any, index: number) => {
          const monthString = value.split(" ");
          if (index == 0) {
            filters[0] = "01/" + months[monthString[0]].index + "/" + monthString[1];
          }
          if (index == 1) {
            let maxOfDay = months[monthString[0]].max;
            const year = parseInt(monthString[1]);
            if (monthString[0] == 'FEB') {
              if ((year & 3) == 0 && ((year % 25) != 0 || (year & 15) == 0)) {
                maxOfDay = 29;
              }
            }
            filters[1] = maxOfDay + "/" + months[monthString[0]].index + "/" + year;
          }
        });
        break;
      }
    }
    this.filters = filters;
    this.dateChange.emit(filters);
  }

  ngOnInit(): void {
    if (this.years.length == 0) {
      const currentYear: number = new Date().getFullYear();
      this.dateFilters.years = [currentYear - 2, currentYear - 1, currentYear];
    } else {
      this.dateFilters.years = this.years;
    }
    this.dateFilters.typeChange();
  }

}
